module.exports = __webpack_public_path__ + "static/media/goals.4d1bbc12.png";